import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CcLoginComponent, PasswordRecoverComponent, CcRegisterComponent } from 'cc-components-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',

})
export class AppComponent implements OnInit {
  title = 'ciencuadras';

  constructor(
    private dialog: MatDialog
  ){}
  
  ngOnInit(): void {
    window.addEventListener('eventFromMfe', (customEvent: any) => {
      const {detail} = customEvent || {}
      this.OpenOnboardingModal(detail);
    })
  }

  OpenOnboardingModal(Onboarding: any){
    this.dialog.closeAll();
    if(Onboarding.modal == 1){
      this.OpenLoginModal(Onboarding.typeUser);
    } 
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    } 
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    } 
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialog.open(CcLoginComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialog.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });   
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });   
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialog.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }
}
